"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var Policies_1 = require("../../classes/Policies");
var classes_controller_1 = __importDefault(require("./classes.controller"));
var classes_html_1 = __importDefault(require("./classes.html"));
function getStudent(UserService, $stateParams, UsersModel) {
    var currentUser = UserService.getCurrentUser();
    return UsersModel.getStudentByID(currentUser.id).then(function (response) {
        return response;
    });
}
getStudent.$inject = ["UserService", "$stateParams", "UsersModel"];
function getPolicy(PoliciesModel) {
    return PoliciesModel.getByID("courses").then(function (response) {
        return (0, Policies_1.createFromSinglePolicyAPIResponse)(response).getPolicyByName("courses");
    });
}
getPolicy.$inject = ["PoliciesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.classes", {
        url: "/classes",
        controller: classes_controller_1.default,
        controllerAs: "vm",
        template: classes_html_1.default,
        resolve: {
            student: getStudent,
            coursesPolicy: getPolicy,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.classes", [])
    .config(config)
    .controller("StudentClassesController", classes_controller_1.default);
